import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { WHITE, BLUE_BUTTON } from "./baseModal/colours";

import "./CheckoutAdjustmentModal.css";

const AddCreditsModal = props => {
  const [creditAmount, setCreditAmount] = useState("");
  const [availableCredits, setAvailableCredits] = useState(0);
  const [loading, setLoading] = useState(false);
  
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;

    const fetchUserCredits = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/par/orders/stripe-customer-balance?dsUserId=${props.userId}&partnerId=${props.partnerId}`
        );
        if (response.data.success && isMounted.current) {
          setAvailableCredits(-response.data.data.balance);
        }
      } catch (error) {
        console.error("Error fetching credits:", error);
      }
    };
  
    fetchUserCredits();
  
    return () => {
      isMounted.current = false;
    };
  }, [props.userId, props.partnerId]);

  const submitForm = async e => {
    e.preventDefault();
    if (loading) return;
    //console.log("creditAmount", creditAmount);
    const amount = parseFloat(creditAmount);
    //console.log("amount", amount);
    if (isNaN(amount) || amount <= 0) {
      toast.error("Please enter a valid credit amount");
      return;
    }
    if (amount *100 > availableCredits) {
      toast.error("Amount exceeds available credits");
      return;
    }
    if (amount *100 > props.totalAmount) {
      toast.error("Credit amount cannot exceed total amount");
      return;
    }

    setLoading(true);
    try {
      /*const response = await axios.post(
        `${process.env.REACT_APP_API}/par/orders/credit`,
        {
          dsUserId: props.userId,
          partnerId: props.partnerId,
          amount: -amount * 100, 
          reason: "used credit during checkout",
        }
      );*/
  
      //if (response.data.success && isMounted.current) {
        console.log("Calling onApplyCredits with amount:", amount * 100);
        props.onApplyCredits(amount*100);
        setTimeout(() => {
          if (isMounted.current) {
            props.onClose();
          }
        }, 100);
      //} 
      /*else {
        toast.error("Error applying credits");
      }*/
    } catch (error) {
      if (isMounted.current) {
        toast.error("Error applying credits");
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  //console.log("props.totalAmount", props.totalAmount);
  //console.log("availableCredits", availableCredits);
  return (
    <div className="request-modal-cont checkout-adjustment-modal">
      <div className="request-modal lesspadding">
        <div className="checkout-adjustment-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "48px",
            marginBottom: "1.5rem"
          }}
        >
          <h2 style={
            {
              color: BLUE_BUTTON ,
              fontSize: "1.7rem" ,
              fontFamily: "futura-pt, sans-serif",
              fontWeight: "650" ,
              margin: "0",
            }
          } >Apply Credits</h2>
          <IconButton className="checkout-adjustment-close" aria-label="Close credits dialog"
            style={{
              borderRadius: "50%",
              color: BLUE_BUTTON,
              marginBottom: "1rem"
            }}
            onClick={() => props.onClose()}
          >
            <Close />
          </IconButton>
        </div>
        <form onSubmit={e => submitForm(e)}>
          <div
            className="form-group"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px"
            }}
          >
            <label
              style={{
                width: "25%",
                textAlign: "left",
                fontSize: "1.25rem",
                fontFamily: "futura-pt, sans-serif",
                fontWeight: "500",
                color: "#626262"
              }}
            >
              Total Credits
            </label>
            <div
              style={{
                width: "70%",
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                backgroundColor: "#f8f9fa"
              }}
            >
              ${(availableCredits/100).toFixed(2)}
            </div>
          </div>

          <div
            className="form-group"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px"
            }}
          >
            <label
              style={{
                width: "25%",
                textAlign: "left",
                fontSize: "1.25rem",
                fontFamily: "futura-pt, sans-serif",
                fontWeight: "500",
                color: "#626262"
              }}
            >
              Apply Credits 
            </label>
            <input
              type="number"
              step="0.01"
              placeholder="Enter amount ($)"
              value={creditAmount}
              onChange={e => setCreditAmount(e.target.value)}
              style={{
                width: "70%",
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc"
              }}
              required
            />
          </div>

          <div className="modal-footer">
            <button
              type="submit"
              disabled={loading}
              className="base-modal-button"
              style={{
                backgroundColor: BLUE_BUTTON,
                color: WHITE,
                cursor: "pointer"
              }}
            >
              {loading ? "Processing..." : "Apply"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCreditsModal;